import Vue from 'vue'
import { getLink, getJssdkRight, shareToMini, isInTH, getEnv } from '@/utils'
import logUtils from '@/utils/log_util'
import { shareImageConfig } from '../config/constants'
import { wxLogin } from '../utils/wx_login_utils'
import Cookies from 'js-cookie'
import { foreignCountries } from '@/config/foreignCountries'
let shareImgEnv = process.env.CDN_ENV === 'production' ? 'formal' : 'pre'

function keepQuery (to, from, queryList = []) {
  let query = null
  queryList.forEach((key) => {
    if (from.query[key] && !to.query[key]) {
      if (!query) {
        query = {}
      }
      query[key] = from.query[key]
    }
  })
  return query
}

const allRoutes = {
  index: [
    {
      // 首页
      path: '/',
      name: 'home',
      alias: ['/index', '/home'],
      component: () => import('../views/HomeV4.vue'),
      async beforeEnter (to, from, next) {
        document.title = '新冠肺炎疫情动态'
        if (isInTH()) {
          await wxLogin()
        }
        next()
      }
    },
    {
      // 首页纯净版
      path: '/home-pure',
      name: 'home',
      component: () => import('../views/HomePure.vue'),
      async beforeEnter (to, from, next) {
        document.title = '全国新冠肺炎实时动态'
        next()
      }
    },
    {
      path: '/home-v2',
      name: 'homev2',
      component: () => import('../views/HomeV2.vue'),
      async beforeEnter (to, from, next) {
        document.title = '新冠肺炎疫情动态'
        if (isInTH()) {
          await wxLogin()
        }
        next()
      }
    },
    {
      path: '/home-v3',
      name: 'homev3',
      component: () => import('../views/HomeV2.vue'),
      async beforeEnter (to, from, next) {
        document.title = '新冠肺炎疫情动态'
        if (isInTH()) {
          await wxLogin()
        }
        next()
      }
    },
    {
      path: '/home-yd',
      name: 'HomeYd',
      component: () => import('../views/HomeYd.vue')
    },
    {
      path: '/map-landing',
      name: 'mapLanding',
      component: () => import('../views/MapLanding.vue'),
      beforeEnter (to, from, next) {
        let preProvince = +to.query.isprovince === 1 && to.query.province ? to.query.province + '省' : ''
        const shareLink = getLink({
          path: 'map-landing',
          query: to.query,
          needAuth: false,
          $route: to
        })
        shareToMini(
          `${preProvince}医疗救治定点医院和发热门诊导航地图`,
          shareLink,
          shareImageConfig[Vue.prototype.$browserEnv].mapLanding,
          '每日持续更新疫情动态，祝您一直健康！'
        )
        next()
      }
    },
    {
      path: '/map-landing-v2',
      name: 'mapLandingv2',
      component: () => import('../views/MapLandingV2.vue')
    },
    {
      path: '/map-detail',
      name: 'mapDetail',
      component: () => import('../views/MapDetail.vue'),
      props: true,
      async beforeEnter (to, from, next) {
        const { province } = to.query
        const shareTitle = `${province}新冠肺炎疫情实时动态`
        const imageUrl = `https://static.wecity.qq.com/auto-create-image-sotre/wuhan-share-with-number-${shareImgEnv}-${province}.png?x_cache_fresh=on&currentTime=${Date.now()}`
        if (isInTH()) {
          await wxLogin()
        }
        const shareLink = getLink({ path: 'map-detail', query: to.query, needAuth: false, $route: to })
        shareToMini(shareTitle, shareLink, imageUrl)
        next()
      }
    },
    {
      path: '/city-detail',
      name: 'cityDetail',
      component: () => import('../views/CityDetail.vue'),
      props: true,
      async beforeEnter (to, from, next) {
        const { province, cityName } = to.query
        const shareTitle = `${cityName}新冠肺炎疫情实时动态`
        const imageUrl = `https://static.wecity.qq.com/auto-create-image-sotre/wuhan-share-with-number-${shareImgEnv}-${province}-${cityName}.png?x_cache_fresh=on&currentTime=${Date.now()}`
        if (isInTH()) {
          await wxLogin()
        }
        const shareLink = getLink({ path: 'city-detail', query: to.query, needAuth: false, $route: to })
        shareToMini(shareTitle, shareLink, imageUrl)
        next()
      }
    },
    {
      path: '/foreign-detail',
      name: 'foreignDetail',
      component: () => import('../views/ForeignDetail.vue'),
      props: true,
      async beforeEnter (to, from, next) {
        const { country } = to.query
        const shareTitle = `${country}新冠肺炎疫情实时动态`
        const detailCountries = foreignCountries
        let imageUrl = `https://static.wecity.qq.com/auto-create-image-sotre/wuhan-share-with-number-${shareImgEnv}-haiwai.png?x_cache_fresh=on&currentTime=${Date.now()}`
        if (detailCountries.includes(country)) {
          imageUrl = `https://static.wecity.qq.com/auto-create-image-sotre/wuhan-share-with-number-${shareImgEnv}-${country}.png?x_cache_fresh=on&currentTime=${Date.now()}`
        }
        if (isInTH()) {
          await wxLogin()
        }
        const shareLink = getLink({ path: 'foreign-detail', query: to.query, needAuth: false, $route: to })
        shareToMini(shareTitle, shareLink, imageUrl)
        next()
      }
    },
    {
      path: '/dailyReport',
      name: 'DailyReport',
      component: () => import('../views/DailyReport.vue')
    },
    {
      path: '/check-self',
      name: 'CheckSelf',
      component: () => import('../views/CheckSelf.vue')
    },
    {
      path: '/check-self-result',
      name: 'CheckSelfResult',
      component: () => import('../views/CheckSelfResult.vue')
    },
    {
      path: '/hospital-donate',
      name: 'HospitalDonate',
      component: () => import('../views/HospitalDonate.vue'),
      beforeEnter (to, from, next) {
        document.title = '新冠肺炎疫情动态'
        const shareLink = getLink({ path: 'hospital-donate', query: to.query, needAuth: false, $route: to })
        shareToMini((to.query.hospitalName || '') + '防疫物资捐助', shareLink, shareImageConfig[Vue.prototype.$browserEnv].mapLanding, '感谢您的爱心，共克时艰战疫情')
        // document.title = (to.query.cityName + '市' || '') + document.title
        next()
      }
    },
    {
      path: '/facemask-apply',
      name: 'FaceMaskApply',
      component: () => import('../views/FaceMaskApply.vue'),
      beforeEnter (to, from, next) {
        console.log('🌟 to, from', to, from)
        const shareLink = getLink({ path: 'facemask-apply', query: to.query, needAuth: false, $route: to })
        shareToMini('全国口罩预约渠道信息汇总（持续更新）', shareLink, 'https://static.wecity.qq.com/h5/2020-2/WechatIMG109-cd2b9620d2ffbdcb140f68a7f1dafd30.jpeg', '全国口罩预约渠道信息汇总（持续更新）')
        // document.title = (to.query.cityName + '市' || '') + document.title
        next()
      }
    },
    {
      path: '/nucleic-hospital',
      name: 'NucleicHospital',
      component: () => import('../views/NucleicHospital.vue'),
      beforeEnter (to, from, next) {
        console.log('🌟 to, from', to, from)
        const shareLink = getLink({ path: 'nucleic-hospital', query: to.query, needAuth: false, $route: to })
        shareToMini('新冠病毒核酸定点检测机构信息汇总（持续更新）', shareLink, 'https://static.wecity.qq.com/h5/2020-4/879723363666-1bc0a1938447475657ff5f03ece5fd34.png', '全国新冠病毒核酸定点检测机构一览表')
        // document.title = (to.query.cityName + '市' || '') + document.title
        next()
      }
    },
    {
      path: '/feiyanmap',
      name: 'FeiYanMap',
      component: () => import('../views/FeiYanMap.vue'),
      beforeEnter (to, from, next) {
        const cityCode = to.query.cityCode
        const provinceName = to.query.provinceName
        const channel = to.query.channel
        if (/^\d+0{4}$/.test(cityCode) && !/110000|120000|500000|310000/.test(cityCode)) {
          console.log(cityCode, provinceName)
          next({
            path: '/map-landing',
            query: {
              provinceCode: cityCode,
              province: provinceName,
              isprovince: '1',
              channel,
              random: new Date().getTime()
            }
          })
        } else {
          if (to.query.cityCode) {
            const shareLink = getLink({
              path: 'feiyanmap',
              query: to.query,
              needAuth: false,
              $route: to
            })
            let title = '定点医院和发热门诊地图'
            if (to.query.cityName) {
              title = to.query.cityName + title
            }
            shareToMini(
              title,
              shareLink,
              'https://static.wecity.qq.com/h5/feiyan-df80a50ac8409168a0461961a88328d3.jpg',
              '每日持续更新疫情动态，祝您一直健康'
            )
            document.title = title

            next()
          } else {
            // 不带 cityCode 则跳到发热门诊首页
            next({
              path: '/map-landing',
              query: {
                random: new Date().getTime()
              },
              replace: true
            })
          }
        }
      }
    },
    // 非小程序内引导用户订阅
    {
      path: '/guide-subscription',
      name: 'GuideSubscription',
      component: () => import('../views/GuideSubscription.vue')
    },
    {
      path: '/jump-transport-query',
      name: 'JumpTransportQuery',
      component: () => import('../views/JumpTransportQuery.vue')
    },
    {
      path: '/hospital',
      name: 'FeiYanHospital',
      component: () => import('../views/FeiYanHospital.vue'),
      beforeEnter (to, from, next) {
        const shareLink = getLink({ path: 'hospital', query: to.query, needAuth: false, $route: to })
        shareToMini((to.query.hospitalName || '') + '新冠肺炎就医指引', shareLink, shareImageConfig[Vue.prototype.$browserEnv].mapLanding, '医院实时人流情况、医院公告、症状自查与就医建议')
        document.title = ''
        next()
      }
    },
    {
      path: '/psychologyHtl',
      name: 'PsychologyHotline',
      component: () => import('../views/PsychologyHotline.vue'),
      beforeEnter (to, from, next) {
        const shareLink = getLink({ path: 'psychologyHtl', query: to.query, needAuth: false, $route: to })
        document.title = '疫情心理援助热线'
        // console.log('shareLink', )
        shareToMini('全国疫情心理援助热线查询', shareLink, 'https://static.wecity.qq.com/h5/2020-2/疫情心理热线分享图-a722a7c36618c662e69ef78308bd3392.png', '数据来自权威媒体收集并持续更新')
        next()
      }
    },
    {
      path: '/feiyan-more-tools',
      name: 'FeiYanMoreTools',
      component: () => import('../views/FeiYanMoreTools.vue'),
      beforeEnter (to, from, next) {
        const shareLink = getLink({ path: 'feiyan-more-tools', query: to.query, needAuth: false, $route: to })
        document.title = '腾讯健康抗疫服务工具箱'
        // console.log('shareLink', )
        shareToMini('腾讯健康抗疫服务工具箱', shareLink, 'https://static.wecity.qq.com/h5/2020-2/more-tools-9d53f6d281f30f68c88aec94b1db9b92.jpg', '您的抗击疫情助手，持续更新抗疫服务。祝您一直健康！')
        next()
      }
    },
    {
      path: '/preview',
      name: 'FeiYanPreview',
      component: () => import('../views/FeiYanPreview.vue'),
      beforeEnter (to, from, next) {
        console.log('🌟 to, from', to, from)
        document.title = ''
        next()
      }
    },
    {
      path: '/case-details',
      name: 'CaseDetails',
      component: () => import('../views/CaseDetails.vue'),
      beforeEnter (to, from, next) {
        // console.log('🌟 to, from', to, from)
        document.title = '确诊病例个案分析'
        const shareLink = getLink({ path: 'case-details', query: to.query, needAuth: false, $route: to })
        shareToMini('确诊病例个案分析', shareLink, '', '')
        next()
      }
    },
    {
      // 兜底去首页
      path: '*',
      name: 'default',
      component: () => import('../views/HomeV4.vue'),
      async beforeEnter (to, from, next) {
        document.title = '新冠肺炎疫情动态'
        if (isInTH()) {
          await wxLogin()
        }
        next()
      }
    },
  ],
  bless: [
    {
      path: '/bless',
      name: 'BlessIndex',
      component: () => import('../views/BlessIndex.vue')
    },
    {
      path: '/bless/activity',
      name: 'BlessActivity',
      component: () => import('../views/BlessActivity.vue')
    },
    {
      path: '/bless/image',
      name: 'BlessBigImage',
      component: () => import('../views/BlessBigImage.vue')
    }
  ],
  selftest: [
    // 自助排查
    {
      path: '/selftest',
      name: 'Selftest',
      component: () => import('../views/Selftest.vue'),
      beforeEnter (to, from, next) {
        const shareLink = getLink({
          path: 'selftest',
          needAuth: false,
          $route: to,
          query: to.query
        })
        shareToMini(
          '腾讯健康-新冠肺炎自查工具',
          shareLink,
          shareImageConfig[Vue.prototype.$browserEnv].selftest,
          '担心是否感染？新冠肺炎智能筛查助手帮您自我评估和排查'
        )
        next()
      }
    },
    // 自助排查报告页
    {
      path: '/selftest-report',
      name: 'SelftestReport',
      component: () => import('../views/modules/selftest/report.vue')
      // beforeEnter (to, from, next) {
      //   // 手Q推广需要，临时更换到下面的自查页
      //   // const shareLink = getLink({
      //   //   path: 'selftest-report',
      //   //   needAuth: false,
      //   //   $route: to,
      //   //   query: { caseId: logUtils.getUserId(), ...to.query }
      //   // })
      //   // shareToMini(
      //   //   '腾讯健康—新冠肺炎自查报告',
      //   //   shareLink,
      //   //   shareImageConfig[Vue.prototype.$browserEnv].selftest,
      //   //   '分享我的自查报告'
      //   // )
      //   const shareLink = getLink({
      //     path: 'selftest',
      //     needAuth: false,
      //     $route: to,
      //     query: to.query
      //   })
      //   shareToMini(
      //     '腾讯健康-新冠肺炎自查工具',
      //     shareLink,
      //     shareImageConfig[Vue.prototype.$browserEnv].selftest,
      //     '担心是否感染？新冠肺炎智能筛查助手帮您自我评估和排查'
      //   )
      //   next()
      // }
    },
    // ai智能问答
    {
      path: '/aiqna',
      name: 'AIQA',
      component: () => import('../views/AIQA.vue'),
      beforeEnter (to, from, next) {
        try {
          const { forceReload } = to.query
          if (forceReload) {
            sessionStorage.setItem('AIQA_MESSAGES', JSON.stringify([]))
            sessionStorage.setItem('AIQA_ALERT', JSON.stringify({}))
            sessionStorage.setItem('AIQA_MORE_BOX', JSON.stringify({}))
            // location.reload()
          }
        } catch (e) {
          console.log('强制刷新失败')
          console.log(e)
        }

        console.log('🌟 to, from', to, from)
        console.log(
          '====',
          Vue.prototype.$browserEnv,
          shareImageConfig[Vue.prototype.$browserEnv].aiqna
        )
        document.title = '新冠肺炎疫情动态'
        const shareLink = getLink({
          path: 'aiqna',
          needAuth: false,
          $route: to
        })
        shareToMini(
          '腾讯健康-新冠肺炎智能问答',
          shareLink,
          shareImageConfig[Vue.prototype.$browserEnv].aiqna,
          '疫情知识知多少？新冠肺炎智能问答助手为您答疑解惑'
        )
        next()
      }
    }
  ],
  document: [
    {
      path: '/article-map-api-document',
      name: 'MapApiArticle',
      component: () => import('../views/MapApiArticle.vue')
    },
    {
      path: '/article-map-hosp-document',
      name: 'MapHospArticle',
      component: () => import('../views/MapHospArticle.vue')
    },
    {
      path: '/feiyan-tools-guide',
      name: 'FeiYanToolsGuide',
      component: () => import('../views/FeiyanToolsGuide.vue'),
      beforeEnter (to, from, next) {
        document.title = '合作指引及接入指南'
        next()
      }
    }
  ],
  act: [
    {
      path: '/feiyan-act',
      name: 'FeiYanActivity',
      component: () => import('../views/FeiYanActivityV2.vue'),
      beforeEnter (to, from, next) {
        const shareLink = getLink({ path: 'feiyan-act', query: to.query, needAuth: false, $route: to })
        console.log('test', shareLink)
        let url = 'https://static.wecity.qq.com/h5/2020-2/feiyan-act-14271b3dc7f30101506cbb92f2b302d9.jpg'
        if (Vue.prototype.$browserEnv === 'mini') {
          url = 'default'
        }
        shareToMini('最新！有确诊患者的小区名单', shareLink, url, '新冠肺炎确诊患者去过哪些地方？这里全都有')
        next()
      }
    },
    {
      path: '/feiyan-act-map',
      name: 'FeiYanActivityMap',
      component: () => import('../views/FeiYanActivityMap.vue'),
      beforeEnter (to, from, next) {
        const shareLink = getLink({ path: 'feiyan-act-map', query: to.query, needAuth: false, $route: to })
        shareToMini('最新！有确诊患者的小区名单', shareLink, 'https://static.wecity.qq.com/h5/2020-2/feiyan-act-14271b3dc7f30101506cbb92f2b302d9.jpg', '新冠肺炎确诊患者去过哪些地方？这里全都有')
        next()
      }
    },
    {
      path: '/feiyan-act-sub-guide',
      name: 'FeiYanActivitySubscriptionGuide',
      component: () => import('../views/FeiYanActivitySubscriptionGuide.vue'),
      async beforeEnter (to, from, next) {
        document.title = '地区动态订阅'
        const shareLink = getLink({ path: 'feiyan-act', query: to.query, needAuth: false, $route: to })
        shareToMini('最新！有确诊患者的小区名单', shareLink, 'https://static.wecity.qq.com/h5/2020-2/feiyan-act-14271b3dc7f30101506cbb92f2b302d9.jpg', '新冠肺炎确诊患者去过哪些地方？这里全都有')
        next()
      }
    },
    {
      path: '/feiyan-act-sub',
      name: 'FeiYanActivitySubscription',
      component: () => import('../views/FeiYanActivitySubscription.vue'),
      async beforeEnter (to, from, next) {
        document.title = '地区动态订阅'
        const shareLink = getLink({ path: 'feiyan-act', query: to.query, needAuth: false, $route: to })
        shareToMini('最新！有确诊患者的小区名单', shareLink, 'https://static.wecity.qq.com/h5/2020-2/feiyan-act-14271b3dc7f30101506cbb92f2b302d9.jpg', '新冠肺炎确诊患者去过哪些地方？这里全都有')
        await wxLogin()
        next()
      }
    }
  ],
  travel: [
    // 出行助手查询页
    {
      path: '/travel',
      name: 'Travel',
      component: () => import('../views/Travel.vue'),
      beforeEnter (to, from, next) {
        const shareLink = getLink({
          baseHtml: 'travel.html',
          path: 'travel',
          needAuth: false,
          $route: to,
          query: to.query
        })
        shareToMini(
          '腾讯健康-出行助手',
          shareLink,
          shareImageConfig[Vue.prototype.$browserEnv].travel,
          ''
        )
        next()
      }
    },
    // 出行助手结果页
    {
      path: '/travel/detail',
      name: 'TravelDetail',
      component: () => import('../views/TravelDetail.vue'),
      beforeEnter (to, from, next) {
        const shareLink = getLink(
          {
          baseHtml: 'travel.html',
          path: 'travel/detail',
          needAuth: false,
          $route: to,
          query: to.query
        })
        shareToMini(
          '腾讯健康-出行助手',
          shareLink,
          // TODO: 补充分享图
          shareImageConfig[Vue.prototype.$browserEnv].travel,
          ''
        )
        next()
      }
    },
  ],
}

export default allRoutes

export const beforeEach = (currentModuleName) => {
  // 找到不是当前模块的所有path
  let otherModulePageNames = []
  for (const moduleName in allRoutes) {
    if (moduleName !== currentModuleName && allRoutes.hasOwnProperty(moduleName)) {
      const routes = allRoutes[moduleName]
      otherModulePageNames = otherModulePageNames.concat(routes.map(item => {
        const includePageName = otherModulePageNames.find(eachOtherModule => eachOtherModule.path === item.path)
        if (includePageName) {
          console.error('拆了多页面之后，一定要把原来的页面路由在index里面删掉！！！！！')
          console.error('没删掉的页面是', item)
        }
        return {
          module: moduleName,
          path: item.path,
          name: item.name
        }
      }))
    }
  }
  return async (to, from, next) => {
    console.log('🌟 to, from', to, from)
    // 路由透传白名单
    const queryList = ['channel', 'minitype']
    const patchQuery = keepQuery(to, from, queryList)
    if (patchQuery) {
      console.log('patchQuery---', patchQuery)
      next({
        path: to.path,
        query: Object.assign({}, to.query, patchQuery),
        replace: !!from.name
      })
    } else {
      // 如果通过router.push 跳转的页面，不在当前模块里
      // 要通过location的方式跳转到对应的页面
      const otherModule = otherModulePageNames.find(item => item.path === to.path || item.name === to.name)
      if (otherModule) {
        const redirect = (href) => {
          // 如果是刚进来就重定向（老的页面给出去的比如index.html#/bless）这种情况会默认产生一次重定向的记录，返回的话会有问题，用location.replace，如果是
          if (from.name === null) {
            location.replace(href)
          } else {
            location.href = href
          }
        }
        let path = to.fullPath
        if (to.matched.length === 0 && to.fullPath === '/') {
          path = `${otherModule.path}`
        }
        const reg = new RegExp(`(${currentModuleName}\.(html)?\/?)$`)
        if (reg.test(location.pathname)) {
          redirect(`${location.origin}${location.pathname.replace(reg, `${otherModule.module}.html`)}#${path}`)
        } else if (location.pathname.slice(-1) === '/') {
          redirect(`${location.origin}${location.pathname}${otherModule.module}.html#${path}`)
        } else {
          redirect(`${location.origin}${location.pathname}/${otherModule.module}.html#${path}`)
        }
        return
      }
      // 小程序带过来的miniuserid种进cookie
      if (Vue.prototype.$browserEnv === 'mini' && to.query.miniuserid) {
        console.log('🍓 set cookie miniuserid')
        Cookies.set('_txjk_feiyanh5_miniuserid', to.query.miniuserid, {
          domain: '.qq.com',
          path: '/',
          expires: 31 * 6
        })
      }
      // 判断微信环境下，才需要拿签名
      if (Vue.prototype.$browserEnv === 'wx' && getEnv() !== 'local') {
        await getJssdkRight()
      }
      const shareLink = getLink({ path: 'home', needAuth: false, $route: to })
      shareToMini('新冠肺炎疫情动态', shareLink)
      next()
    }
  }
}

export const scrollBehavior = (to, from, savedPosition) => {
  const needSavePaths = ['home', 'homev2']
  const needSave = needSavePaths.indexOf(to.name) !== -1
  if (savedPosition && needSave) {
    return savedPosition
  } else if (!needSave) {
    return { x: 0, y: 0 }
  }
}
